import { createFileRoute, redirect } from "@tanstack/react-router";

// The page was renamed when triggers gained a second kind; kept for bookmarks.
export const Route = createFileRoute(
	"/_authenticated/dashboard/agents/$agentId/schedule",
)({
	beforeLoad: ({ params }) => {
		throw redirect({
			to: "/dashboard/agents/$agentId/triggers",
			params,
			replace: true,
		});
	},
});
